import { Link, useSearchParams } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { CheckCircle2, UserPlus } from 'lucide-react';

export default function CheckoutSuccessPage() {
  const { t } = useLanguage();
  const [searchParams] = useSearchParams();
  const paymentId = searchParams.get('payment_id');

  const loginUrl = paymentId
    ? `/login?from=checkout_success&payment_id=${encodeURIComponent(paymentId)}&redirect=${encodeURIComponent('/checkout/success')}`
    : '/login?from=checkout_success&redirect=/checkout/success';

  return (
    <div className="min-h-screen bg-neutral-950 flex flex-col">
      <div className="flex flex-1 flex-col items-center justify-center px-4 py-16">
        <Link
          to="/"
          className="mb-12 inline-block"
          aria-label="Maison Adji"
        >
          <img
            src="/assets/images/maisonadjiwhite.png"
            alt="Maison Adji"
            className="h-8 w-auto object-contain opacity-90 hover:opacity-100 transition-opacity"
          />
        </Link>

        <div className="w-full max-w-md text-center">
          <div className="mx-auto mb-8 flex h-20 w-20 items-center justify-center rounded-full border border-white/10 bg-white/5">
            <CheckCircle2 className="h-12 w-12 text-emerald-400" />
          </div>
          <h1 className="font-['Sora'] text-2xl md:text-3xl font-light tracking-tight text-white mb-4">
            {t('checkout.success_title')}
          </h1>
          <p className="font-['Rubik'] text-sm text-white/60 leading-relaxed mb-2">
            {t('checkout.success_message')}
          </p>
          {paymentId && (
            <p className="font-['DM_Mono'] text-xs text-white/40 mb-8">
              Réf. {paymentId}
            </p>
          )}
          {!paymentId && <div className="h-8" />}

          <Link
            to="/"
            className="inline-flex w-full items-center justify-center rounded-full border border-white/30 bg-white px-6 py-4 font-['Rubik'] text-xs tracking-[0.2em] uppercase text-neutral-900 transition-colors hover:bg-white/90 mb-6"
          >
            {t('checkout.success_continue')}
          </Link>

          <div className="rounded-xl border border-white/10 bg-white/5 px-6 py-5 text-left">
            <div className="flex items-center gap-3 mb-2">
              <UserPlus className="h-5 w-5 text-white/60 shrink-0" />
              <h2 className="font-['Sora'] text-sm font-medium text-white">
                {t('checkout.success_track_title')}
              </h2>
            </div>
            <p className="font-['Rubik'] text-xs text-white/50 leading-relaxed mb-4">
              {t('checkout.success_track_message')}
            </p>
            <Link
              to={loginUrl}
              className="inline-flex w-full items-center justify-center gap-2 rounded-full border border-white/20 px-4 py-3 font-['Rubik'] text-xs tracking-[0.15em] uppercase text-white/90 transition-colors hover:bg-white/10 hover:text-white"
            >
              {t('checkout.success_track_cta')}
            </Link>
          </div>
        </div>
      </div>

      <footer className="border-t border-white/10 py-6 text-center">
        <p className="font-['Rubik'] text-xs text-white/30 tracking-widest uppercase">
          Maison Adji
        </p>
      </footer>
    </div>
  );
}
